import classnames from 'classnames/bind'
import { useRouter } from 'next/router'

// Libs
import handleRoutePushWithQuery from '@/methods/url/handleRoutePushWithQuery'

// Libs

// Types
import { MultiDropdownResponse } from '@/api/fetchMultiDropdownValue'
// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type TabsProps = {
  shopHomeFeaturedList: MultiDropdownResponse['shopHomeFeatured']
}

const CategoryTabs = (props: TabsProps) => {
  const { shopHomeFeaturedList } = props

  const router = useRouter()
  const { query, pathname } = router

  const handleTabClick = (value: string) => {
    handleRoutePushWithQuery({
      router,
      pathname,
      query: { ...query, category: value },
      isReplace: true,
      scroll: false,
    })
  }

  return (
    <div className={cx('category-tabs-container')}>
      {shopHomeFeaturedList?.map((tab) => (
        <button key={tab.value} className={cx('tab-item', { active: tab.value === query.category })} onClick={() => handleTabClick(tab.value)}>
          {tab.name}
        </button>
      ))}
    </div>
  )
}

export default CategoryTabs
